export const daysOfMonth = Array.from({ length: 28 }, (_, day) => ({
  id: day + 1,
  value: `${day + 1}`
}));

export const maskingDots = '\u25CF\u25CF\u25CF\u25CF';
